import axios, { AxiosError } from 'axios';
import type { TFunction } from 'i18next';

/**
 * Messages affichés à l'apprenant : jamais de texte brut Axios / stack / anglais technique.
 */
export function getLearnerFacingApiError(error: unknown, t: TFunction): string {
  if (axios.isAxiosError(error)) {
    const ax = error as AxiosError<{ error?: string; code?: string }>;

    if (
      ax.code === 'ECONNABORTED' ||
      ax.code === 'ETIMEDOUT' ||
      (typeof ax.message === 'string' && ax.message.toLowerCase().includes('timeout'))
    ) {
      return t('common.errorTimeout');
    }

    if (ax.code === 'ERR_NETWORK' || ax.message === 'Network Error') {
      return t('common.errorNetwork');
    }

    const status = ax.response?.status;

    if (status === 403 && ax.response?.data?.code === 'COURSE_LOCKED') {
      return t('courseDetail.courseLockedTitle');
    }

    if (status === 403) {
      return t('courseDetail.accessDenied');
    }

    if (status === 404) {
      return t('common.notFound');
    }

    if (status === 401) {
      return t('common.unexpectedError');
    }

    return t('common.unexpectedError');
  }

  return t('common.unexpectedError');
}
